import { Component, Watch } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import EditorComponent from './EditorComponent.vue';
import PreviewSourceVideo from '@/components/editor/templates/PreviewSourceVideo.vue';

const EXCLUDED_KEY_EVENT_INPUT_NAMES = [
  'positionX',
  'positionY',
  'sizeW',
  'sizeH'
];

@Component({
  components: {
    EditorComponent,
    PreviewSourceVideo,
  },
})
export default class CanvasMixin extends EditorBase {
  isAllowToMoveWithKeys = true;
  scaleFactor = 1;

  $refs!: {
    canvasContainer: HTMLElement;
  };

  async mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('focusin', this.handleFocusChanged);
    window.addEventListener('focusout', this.handleFocusChanged);
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('focusin', this.handleFocusChanged);
    window.removeEventListener('focusout', this.handleFocusChanged);
  }

  getZIndexByArrayIndex(index) {
    return this.components.length - index;
  }

  handleKeyDown(event) {
    if (!this.selectedComponent || event.keyCode < 36 || event.keyCode > 40 || !this.isAllowToMoveWithKeys) return;

    let movement = {};

    switch (event.keyCode) {
      case 37:
        movement['x'] = this.selectedComponentCanvasSettings.x - 1;
        break;

      case 39:
        movement['x'] = this.selectedComponentCanvasSettings.x + 1;
        break;

      case 38:
        movement['y'] = this.selectedComponentCanvasSettings.y - 1;
        break;

      case 40:
        movement['y'] = this.selectedComponentCanvasSettings.y + 1;
        break;
    }

    if (this.isVerticalEditor) {
      movement = { verticalSettings: { ...movement } };
    }

    this.onComponentUpdate({ ...this.selectedComponent, ...movement });
  }

  handleFocusChanged(event) {
    if (
      event.type === 'focusin' &&
      event.target?.name &&
      EXCLUDED_KEY_EVENT_INPUT_NAMES.includes(event.target.name)
    ) {
      this.isAllowToMoveWithKeys = false;
      return;
    }

    this.isAllowToMoveWithKeys = true;
  }
}
